import { ValueOf } from '@approvalmax/types';
import { selectors } from 'modules/common';
import { backend, domain } from 'modules/data';
import { Company } from 'shared/data/webApp/v2';

export const isPayAvailableViaLicense = ({
    licenseFeatures,
    licenseProductPlan,
    integration,
}: Pick<selectors.types.ExpandedCompany, 'licenseFeatures' | 'licenseProductPlan' | 'integration'>) =>
    getIsPayAvailableViaLicense({ licenseFeatures, licenseProductPlan, countryCode: integration?.countryCode });

export const isPayAvailableViaLicenseV2 = (company?: Company) =>
    getIsPayAvailableViaLicense({
        licenseFeatures: (company?.productPlanFeatures as domain.CompanyLicenseFeature[]) || [],
        licenseProductPlan: (company?.productPlanId as domain.CompanyPlan) || [],
        countryCode: (company?.integrationVersion as backend.OrganisationVersion) || [],
    });

export const getIsPayAvailableViaLicense = ({
    licenseFeatures,
    licenseProductPlan,
    countryCode,
}: {
    licenseFeatures: domain.CompanyLicenseFeature[];
    licenseProductPlan: domain.CompanyPlan;
    countryCode?: ValueOf<backend.OrganisationVersion>;
}) => {
    return (
        licenseFeatures.includes(domain.CompanyLicenseFeature.Pay) &&
        (![domain.CompanyPlan.Trial, domain.CompanyPlan.Partner, domain.CompanyPlan.Retired].includes(
            licenseProductPlan
        ) ||
            ([domain.CompanyPlan.Trial, domain.CompanyPlan.Partner, domain.CompanyPlan.Retired].includes(
                licenseProductPlan
            ) &&
                countryCode === 'UnitedKingdom'))
    );
};
